import { H2, Section } from "@dgs/core";
import { FC } from "react";
import styled from "styled-components";

const Header = styled(H2)`
	padding: ${({ theme }) => theme.spacing(5)} 0;
`;

const StyledSection = styled(Section)`
	display: grid;
	justify-content: center;
	align-items: center;
`;

interface Props {
	headline: string;
	text: string;
}

export const TextPage: FC<Props> = ({ headline, text }) => {
	return (
		<StyledSection color="content">
			<Header>{headline}</Header>
			<p>{text}</p>
		</StyledSection>
	);
};
